// extracted by mini-css-extract-plugin
export default {"PDFReportViewer__fontSizeRadioGroupContainer":"PDFReportViewer_PDFReportViewer__fontSizeRadioGroupContainer__X0ytO"};